<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="tag.tag_id && tag.tag_id > 0"
                                @invoke-method="dbGetTag(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="tag.tag_id && tag.tag_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('tags.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in tag_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != tag.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('tags.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_tag.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'tags' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="tag.status" class="ribbon ribbon-top-right" :class="`ribbon-${tag.status_class}`"><span class="ribbon-span">{{ tag.status }}</span></div>
                        <v-form ref="formTag">
							<v-flex xs12>
								<v-text-field
									v-focus="tag_dialog"
									v-model="tag.tag"
									:label="`${$t('lang.tag')} *`"
									:counter="showCounter(tag.tag, 'tags.tag')"
									:rules="ifValid('tags.tag')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="tag.company_id"
									:label="`${$t('lang.company_id')} *`"
									:items="customers"
									item-value="company_id"
									item-text="company"
									:rules="ifValid('tags.company_id')"
								></bc-autocomplete>
							</v-flex>


                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'tags' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveTags">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_tag"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_tag')"
                :message="$t('lang.delete_tag_confirm')"
                @onConfirm="deleteTags()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_tag_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteTagDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            tag: { },
            file_name: "",
            dbGetTag: _.debounce(this.getTag, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchTag", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.tag) {
                        this.tag = this.assignObj2(data.tag, this.rules_tags);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=tag_status&sort_by=2",
                            method: "get",
                            stateProperty: "tag_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "tags", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchTag", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.tag) {
                        next((vm) => {
                            vm.tag = vm.assignObj2(data.tag, vm.rules_tags);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=tag_status&sort_by=2",
                                method: "get",
                                stateProperty: "tag_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "tags", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=tag_status&sort_by=2",
            method: "get",
            stateProperty: "tag_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_tags: (state) => state.tags.rules_tags,
            tag_status_options: (state) => state.settings.tag_status_options,
            tags: (state) => state.tags.tags,
            selectedTag: (state) => state.tags.selectedTag,

        }),
    },
    methods: {
        ...mapActions([
            "fetchTag",
            "saveTag",
            "deleteTag",
            "printTag",
			"fetchCustomers",

        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getTag(pg_refresh = false) {
            this.startLoader();

            this.fetchTag({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.tag) {
                    this.tag = this.assignObj2(data.tag, this.rules_tags);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printTag({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.tag) {
                    if (this.dev_mode) {
                        this.file_name = data.tag.file_name;
                    } else {
                        this.$refs.print.printReport(data.tag.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveTags() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formTag")) {
                    let body = this.prepForm(this.tag, this.rules_tags);

                    this.saveTag({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.tag) {
                            this.$router.push({ name: "tag", params: { id: data.tag.tag_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { tag_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveTags({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.tag) {
                    this.tag = this.assignObj2(data.tag, this.rules_tags);
                }
            });
        },
        deleteTags() {
            this.deleteTag({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {

                    this.validationOff();
                    this.$router.push({ name: "tags" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force=false) {
            this.startLoader();

            if (force == true) {
                await this.fetchTag({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.tag) {
                        this.tag = this.assignObj2(data.tag, this.rules_tags);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

if (this.customers === null || force == true) await this.getCustomers();

        },
    },
    mounted() {
        this.refresh();
    },
    created() {
    },
};
</script>
